export default __webpack_public_path__ + "static/media/22.b01b8f91.png";